import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { api } from "../lib/api";

const CompanyContext = createContext(null);

export function CompanyProvider({ children }) {
  const [companies, setCompanies] = useState([]);
  const [selectedId, setSelectedId] = useState(localStorage.getItem("fd_company") || "all");
  const [ready, setReady] = useState(false);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/companies");
      setCompanies(data);
      const stored = localStorage.getItem("fd_company");
      if (stored && stored !== "all" && !data.find((c) => c.id === stored)) {
        setSelectedId("all");
      }
    } finally {
      setReady(true);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const select = (id) => { setSelectedId(id); localStorage.setItem("fd_company", id); };

  const managed = companies.filter((c) => ["owner", "agent"].includes(c.role));
  const clientOf = companies.filter((c) => c.role === "client");
  const selectedCompany = companies.find((c) => c.id === selectedId) || null;

  const accent = selectedCompany?.theme?.accent || "";
  useEffect(() => {
    const root = document.documentElement;
    if (accent) root.style.setProperty("--fd-accent", accent);
    else root.style.removeProperty("--fd-accent");
  }, [accent]);

  return (
    <CompanyContext.Provider value={{ companies, managed, clientOf, selectedId, selectedCompany, select, refresh: load, ready }}>
      {children}
    </CompanyContext.Provider>
  );
}

export const useCompany = () => useContext(CompanyContext);
